import { useState, useEffect, createContext, useContext } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Dashboard themes
import theme from "assets/theme";

// Dashboard Dark Mode themes
import themeDark from "assets/theme-dark";

// RTL plugins
// eslint-disable-next-line no-unused-vars
import { CacheProvider } from "@emotion/react";

// Dashboard routes
import routes from "./routes";

// Dashboard contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";

// Create a SessionContext
const SessionContext = createContext();

// Custom hook for session management with local storage
// const useSessionManagement = () => {
//   const [userData, setUserData] = useState({
//     loggedIn: localStorage.getItem("loggedIn") === "true",
//     role: localStorage.getItem("role") || "not-logged-in",
//   });

//   useEffect(() => {
//     // Update user data in local storage
//     localStorage.setItem("loggedIn", userData.loggedIn);
//     localStorage.setItem("role", userData.role);
//   }, [userData]);

//   return [userData, setUserData];
// };
export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;

  // const [userData, setUserData] = useState({
  //   loggedIn: localStorage.getItem("loggedIn") === "true",
  //   role: localStorage.getItem("role") || "not-logged-in",
  // });

  const { pathname } = useLocation();
  const { notLoggedInRoutes, superAdminRoutes, adminRoutes, subAdminRoutes } = routes();
  const rState = useSelector((s) => s.user.userData);

  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const navigate = useNavigate();

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // useEffect(() => {
  //   console.log(userData);
  //   document.body.setAttribute("dir", direction);
  // }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  const currentRole = localStorage.getItem("role");

  const currentRoutes =
    currentRole === "superadmin"
      ? superAdminRoutes
      : currentRole === "admin"
      ? adminRoutes
      : currentRole === "sub-admin"
      ? subAdminRoutes
      : notLoggedInRoutes;

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName="Ivy Smartlight"
            routes={currentRoutes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {configsButton}
        </>
      )}
      {layout === "vr" && <Configurator />}
      {/* <SessionContext.Provider value={rState}> */}
      <Routes>
        {getRoutes(currentRoutes)}
        {localStorage.getItem("loggedIn") == "true" ? (
          currentRole === "superadmin" ? (
            <Route path="*" element={<Navigate to="/dashboard" />} />
          ) : currentRole === "admin" ? (
            <Route path="*" element={<Navigate to="/sub-admins" />} />
          ) : (
            <Route path="*" element={<Navigate to="/devices" />} />
          )
        ) : (
          <Route path="*" element={<Navigate to="/sign-in" />} />
        )}
      </Routes>
      {/* </SessionContext.Provider> */}
    </ThemeProvider>
  );
}